import { ThemeOptions } from "@mui/material";

export const muiSelect: ThemeOptions["components"] = {
  MuiSelect: {
    styleOverrides: {
      select: {
        "&:focus": {
          backgroundColor: "transparent",
        },
      },
    },
  },
};
